module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/group-ordering-04-e01562deb2b60cdc26f5f7c3c7d41887.jpg";